import { FaStar } from 'react-icons/fa';
function StarRating({rating = 0, onClick = () => false, className, editable=false}) {
    return (
        <div className={className}>
            {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                    key={star}
                    className={`star ${star <= rating ? 'active' : ''} ${editable ? 'editable' : ''}`}
                    onClick={() => onClick(star)}
                />
            ))}
        </div>
    )
}

export default StarRating